<template>
	<v-dialog
    v-model="dialogIndexConfiguracionTeachers.estatus"
    hide-overlay
    persistent
  >
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Configuracion de teachers</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize ml-4"
              @click="dialogIndexConfiguracionTeachers.estatus = false"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              cerrar
            </v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
	  		  	<v-row >
	  		  		<v-col cols="12" md="6" lg="5">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="filterUsuarios"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>




							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="primary"
							    		x-small
							    		@click="redirectToConfiguracionTeachers(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>


							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>





    <ConfiguracionTeachers
    ref="configuracionTeachers"
    v-model="dialog.estatus"
    :dialogConfiguracionTeachers="dialog"/>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import ConfiguracionTeachers from '@/components/rh/ConfiguracionTeachers.vue'

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import '@/utils/string.extend';


  export default {

    name: "IndexConfiguracionTeachers",
    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
      ConfiguracionTeachers,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      usuarioERP:[],
      usua:[],
      valor:0,




      // Filtros:
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      horarios: [],
      headers: [
        { text: 'ID'                    , value: 'id_usuario'  },
        { text: 'Nombre'                , value: 'nombre_completo'     },
        { text: 'Acciones'              , value: 'actions', sortable: false },
      ],

      dialog: {
        estatus: true
      }
    }),

    props:[
			'dialogIndexConfiguracionTeachers',
	  ],

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),


      filterUsuarios( ){
      	if( this.plantel ){
      		return this.usuarioERP.filter( el=> { return el.id_plantel == this.plantel })
      	}else{
      		return this.usuarioERP
        }
      }
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.usuarioERP = []
        return this.$http.get('usuarios.teachers').then(response=>{
          this.usuarioERP = response.data
          console.log(this.usuarioERP)
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      async redirectToConfiguracionTeachers(item){
        console.log('item desde padre')

        await this.$refs.configuracionTeachers.getUsuarioExiste( item.id_usuario, item.nombre_completo )
        this.dialog.estatus = true
      }









    },
  }
</script>


